import React, { useMemo } from 'react';

import { useCardPageFilters } from '@vlabs/monokit/entities/card/filters';
import { FilterMenuButton } from '@vlabs/monokit/shared/ui/filter-menu';

export function CardPageFilterMenuButton(): React.JSX.Element {
  const { filters } = useCardPageFilters();

  const filtersCount = useMemo(() => {
    let count = 0;
    if (filters.face_ids) count += 1;
    if (filters.create_time__gte || filters.create_time__lt) count += 1;
    if (filters.user_data) count += 1;
    return count;
  }, [filters]);

  return (
    <FilterMenuButton filtersCount={filtersCount} />
  );
}
